
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 132172","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 132183"}},[_c('g',{attrs:{"data-name":"Group","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M13.652 26.333h2.868a1.445 1.445 0 001.593-1.719l-.466-2.06h-5.122l-.467 2.06a1.5 1.5 0 001.594 1.719z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M17.646 22.543l1.969-1.753c1.1-.979 1.15-1.662.273-2.766l-3.471-4.405a1.617 1.617 0 00-2.65 0l-3.473 4.409c-.877 1.1-.877 1.817.273 2.762l1.969 1.753M15.085 13.38v2.88"}})]),_c('g',{attrs:{"data-name":"Group","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"data-name":"Vector","d":"M15.666 6.415h-1.138a1.142 1.142 0 01-1.138-1.139V4.138A1.142 1.142 0 0114.528 3h1.138a1.142 1.142 0 011.139 1.138v1.138a1.142 1.142 0 01-1.139 1.139zM5.138 16.852h1.138a1.142 1.142 0 001.139-1.139v-1.138a1.142 1.142 0 00-1.139-1.138H5.138A1.142 1.142 0 004 14.575v1.138a1.142 1.142 0 001.138 1.139zM25.011 16.852h-1.138a1.142 1.142 0 01-1.138-1.139v-1.138a1.142 1.142 0 011.138-1.138h1.138a1.142 1.142 0 011.139 1.138v1.138a1.142 1.142 0 01-1.139 1.139zM13.391 4.776a8.73 8.73 0 00-7.706 8.662M24.465 13.438a8.734 8.734 0 00-7.66-8.662"}})])])])
          )
        }
      }
    